import React, { ReactElement } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { greys } from '../../../../../styling/theme';
import { Grid, GridProps } from '@mui/material';

interface KidsEditorGridItemProps extends Omit<GridProps, 'item'> {
  className?: string;
}

const useStyles = makeStyles(() => ({
  gridItem: {
    marginBottom: '0.62rem',
    color: 'black',
  },
  generalCardRoot: {
    background: greys.grey900,
    borderRadius: 2,
    overflow: 'hidden',
    width: '100%',
    marginBottom: '0.62rem',
    height: '100%',
  },
}));

function KidsEditorGridItem(
  props: React.PropsWithChildren<KidsEditorGridItemProps>,
): ReactElement {
  const classes = useStyles();
  const { xs, className, ...gridProps } = props;

  return (
    <Grid item xs={xs} {...gridProps}>
      <div className={`${classes.generalCardRoot} ${className || ''}`}>
        {props.children}
      </div>
    </Grid>
  );
}

export default KidsEditorGridItem;
